module.exports = __webpack_public_path__ + "img/MILDRED TATE LETTER, 1940.2c81f069.jpg";